export default "__VITE_ASSET__2e76b4a0__"